export default {
      id: "ic_menu-close-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_menu-close",
      toString: function () {
        return this.url;
      }
    }